import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { PRICE_VALUE, PRODUCT_NAME } from './data/config';
import { tomes } from './data/kit';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { MaterialPreview } from './components/MaterialPreview';
import { KitOverview } from './components/KitOverview';
import { TomeSection } from './components/TomeSection';
import { Bonuses } from './components/Bonuses';
import { TwoOptions } from './components/TwoOptions';
import { PainPoints } from './components/PainPoints';
import { EmotionalTransition } from './components/EmotionalTransition';
import { OfferCountdown } from './components/OfferCountdown';
import { MainOffer } from './components/MainOffer';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { EmotionalClose } from './components/EmotionalClose';
import { FinalOffer } from './components/FinalOffer';
import { Footer } from './components/Footer';
import { MobileBuyBar } from './components/MobileBuyBar';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPixelEvent('ViewContent', {
      content_name: PRODUCT_NAME,
      content_type: 'product',
      value: PRICE_VALUE,
      currency: 'ARS'
    });
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="2zng2onosiqui">
      <div className="min-h-screen w-full bg-brand-cream font-sans text-brand-ink selection:bg-brand-orange/30 selection:text-brand-violet" data-id="element-1" data-mp="33lx0ggmbmoz9">
        <TopBar data-id="element-2" data-mp="38nuorp9kw9z2" />
        <Hero data-id="element-3" data-mp="38o4ct7b2c724" />
        <main className="pb-[calc(88px+env(safe-area-inset-bottom))] md:pb-0" data-id="element-4" data-mp="3dkl60fx4dbm2">
          <MaterialPreview data-id="element-5" data-mp="3dii694660445" />
          <KitOverview data-id="element-6" data-mp="nw2c461hdqr3" />
          <TomeSection tome={tomes[0]} tone="white" data-id="element-7" data-mp="nur6e0oh68xc" />
          <TomeSection tome={tomes[1]} tone="cream" reverse data-id="element-8" data-mp="sunfgec14qjr" />
          <Bonuses data-id="element-9" data-mp="sssq8ntq6c9v" />
          <TwoOptions data-id="element-10" data-mp="swgkjp6zv2pn" />
          <PainPoints data-id="element-11" data-mp="3688dot76uy6" />
          <EmotionalTransition data-id="element-12" data-mp="35gld2do25ji" />
          <OfferCountdown data-id="element-13" data-mp="34nd1wz277z9" />
          <MainOffer data-id="element-14" data-mp="3uct2xiigokzy" />
          <FAQ data-id="element-15" data-mp="3udknzzefn0bz" />
          <CostComparison data-id="element-16" data-mp="3ubriinfk2m5k" />
          <EmotionalClose data-id="element-17" data-mp="3ucje3y95kjvu" />
          <FinalOffer data-id="element-18" data-mp="d4nv7fl6zi1v" />
        </main>
        <Footer data-id="element-19" data-mp="d3mmvivk99nu" />
        <MobileBuyBar data-id="element-20" data-mp="d45tw4joadn3" />
        <PurchaseNotification data-id="element-21" data-mp="d2l6cyvrzuyq" />
      </div>
    </MotionConfig>;
}